import { useEffect, useState } from 'react';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useStudiesApiContext } from '@vivli/core/infrastructure/context';

export function useStudy(studyId: string) {
    const [study, setStudy] = useState<IStudy>();

    const studiesService = useStudiesApiContext();

    useEffect(() => {
        if (!studyId) {
            return;
        }

        studiesService.getStudy(studyId).pipe(first()).subscribe(setStudy);
    }, [studyId]);

    return {
        study,
        setStudy,
    };
}
